<script>
  import { tick } from "svelte"
  import { fly } from "svelte/transition"
  import Fa from "svelte-fa"
  import { faTrashCan } from "@fortawesome/free-regular-svg-icons"
  import { faStarOfLife } from "@fortawesome/free-solid-svg-icons"

  import Rating from "./Rating.svelte"

  export let notes
  export let rating

  let noteUuid = 0

  notes = notes.map((note) => {
    return {
      ...note,
      id: noteUuid++,
      ref: undefined
    }
  })

  function deleteNote(id) {
    notes = notes.filter((note) => note.id != id)
  }

  function addNote(event) {
    if (event.key == "Enter" && event.target.value.length > 0) {
      const note = {
        id: noteUuid++,
        note: event.target.value
      }

      event.target.value = ""
      notes.push(note)
      notes = notes
    }
  }

  function onEditNote(event, i) {
    if (event.key == "Enter") {
      event.preventDefault()

      const newNote = {
        id: noteUuid++,
        note: ""
      }

      notes.splice(i + 1, 0, newNote)
      notes = notes
    }
  }
</script>

<main class="flex flex-col gap-4">
  <div
    class="flex flex-row border-b border-dashed border-slate pb-2 items-center"
  >
    <div class="grow text-xl">Result</div>

    <Rating bind:rating />
  </div>

  <div class="border-l-4 border-success pl-4">
    <div class="flex flex-col gap-1">
      {#each notes as note, i}
        <div
          class="flex flex-row group items-start content-start relative"
          in:fly
          out:fly
        >
          <div class="pt-3 mr-1 text-tiny">
            <Fa icon={faStarOfLife} />
          </div>

          <div
            contenteditable
            class="step-input w-full outline-none !pr-6"
            bind:innerHTML={note.note}
            bind:this={note.ref}
            on:keydown={(event) => onEditNote(event, i)}
          />

          <button
            type="button"
            class="p-2 hidden text-xs absolute group-hover:block right-1 cursor-pointer text-danger hover:text-danger-hover"
            on:click={() => deleteNote(note.id)}
          >
            <Fa icon={faTrashCan} />
          </button>
        </div>
      {/each}
    </div>

    <div class="mt-1">
      <input
        type="text"
        placeholder="+ note"
        on:keydown={(event) => addNote(event)}
      />
    </div>
  </div>
</main>

<style>
  input[type="text"],
  .step-input {
    @apply border text-xl border-transparent bg-transparent appearance-none rounded w-full py-1 px-2 text-fg leading-tight cursor-pointer;
    @apply md:text-base;
    @apply focus:bg-white focus:shadow focus:border focus:outline-none;
    @apply focus:-my-1 focus:py-2;
  }
</style>
